import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "settings-container"
};
const _hoisted_2 = {
  class: "settings-preamble"
};
const _hoisted_3 = {
  class: "blank-answers-container"
};
const _hoisted_4 = {
  class: "blank-answer-row"
};
const _hoisted_5 = {
  class: "blank-answer-case-sensitivity"
};
const _hoisted_6 = {
  class: "blank-answer-case-sensitivity-label"
};
const _hoisted_7 = {
  key: 0,
  class: "blank-answer-error"
};
const _hoisted_8 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_input = _resolveComponent("w-input");
  const _component_icon = _resolveComponent("icon");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_dialog = _resolveComponent("w-dialog");
  return _openBlock(), _createBlock(_component_w_dialog, {
    visible: _ctx.isVisible,
    title: _ctx.$t('chapter.question.fillInTheBlanks.addBlank.modal.textBlank.title'),
    width: "600px",
    class: "blank-as-text-settings-dialog",
    "close-on-outside-click": false,
    onOnDialogClose: _ctx.closeDialog
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_8, [_createVNode(_component_standard_button, {
      outlined: true,
      label: _ctx.$t('chapter.question.fillInTheBlanks.addBlank.modal.textBlank.cancelBtn'),
      onAction: _ctx.cancelSettingsEdit
    }, null, 8, ["label", "onAction"]), _createVNode(_component_standard_button, {
      label: _ctx.$t('chapter.question.fillInTheBlanks.addBlank.modal.textBlank.validateBtn'),
      disabled: !_ctx.realtimeBlankData?.responses.length,
      onAction: _ctx.validateSettings
    }, null, 8, ["label", "disabled", "onAction"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('chapter.question.fillInTheBlanks.addBlank.modal.textBlank.description')), 1), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.realtimeBlankData?.responses, answer => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_w_input, {
        class: _normalizeClass(['blank-answer-label-input', {
          'is-error': _ctx.shouldDisplayError(answer)
        }]),
        value: answer.label,
        type: 'text',
        placeholder: _ctx.$t('chapter.question.fillInTheBlanks.addBlank.modal.textBlank.optionInput.placeholder'),
        resize: "none",
        maxlength: _ctx.LABEL_NB_MAX_CHARS,
        onInput: $event => _ctx.onBlankAnswerLabelUpdate(answer, $event)
      }, null, 8, ["class", "value", "placeholder", "maxlength", "onInput"]), _createElementVNode("span", _hoisted_5, [_createVNode(_component_icon, {
        class: _normalizeClass(['blank-answer-case-sensitivity-icon', {
          'checked': answer.caseSensitive
        }]),
        icon: answer.caseSensitive ? 'checkbox-marked' : 'checkbox-blank-outline',
        onClick: $event => _ctx.toggleBlankAnswerCaseSensitivity(answer)
      }, null, 8, ["class", "icon", "onClick"]), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('chapter.question.fillInTheBlanks.addBlank.modal.textBlank.optionInput.sensitivityCheckbox')), 1)]), _createVNode(_component_icon, {
        class: "delete-answer-icon",
        icon: "delete-outline",
        onClick: $event => _ctx.onBlankAnswerDelete(answer)
      }, null, 8, ["onClick"])]), _ctx.shouldDisplayError(answer) ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('chapter.question.fillInTheBlanks.addBlank.modal.textBlank.optionInput.emptyValueErrorMsg')), 1)) : _createCommentVNode("", true)]);
    }), 256)), _createElementVNode("div", {
      class: "add-blank-item-btn",
      onClick: _cache[0] || (_cache[0] =
      //@ts-ignore
      (...args) => _ctx.addBlankAnswer && _ctx.addBlankAnswer(...args))
    }, [_cache[1] || (_cache[1] = _createTextVNode(" + ", -1)), _createElementVNode("u", null, _toDisplayString(_ctx.$t('chapter.question.fillInTheBlanks.addBlank.modal.textBlank.addAnswerBtn')), 1)])])])]),
    _: 1
  }, 8, ["visible", "title", "onOnDialogClose"]);
}